import React from 'react';
import { formatDate } from './certificateTemplates';

// The printed A4 page. Rendered identically for preview, view and download so
// what the user approves on screen is exactly what html2canvas captures.
const CertificateDocument = React.forwardRef(({ form, domId }, ref) => {
  return (
    <div
      id={domId}
      ref={ref}
      style={{
        width: '794px',
        height: '1123px',
        background: '#f8fbdc',
        border: '2px solid #000',
        fontFamily: 'Arial',
        position: 'relative',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* WATERMARK */}
      <img
        src="/img/logo01.png"
        alt="Watermark"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '620px',
          opacity: 0.06,
        }}
      />

      {/* ======= HEADER : LOGO LEFT / CLINIC NAME CENTRE / DOCTOR RIGHT ======= */}
      <div
        style={{
          padding: '30px 40px 20px',
          borderBottom: '1px solid #000',
          boxSizing: 'border-box',
          position: 'relative',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {/* LEFT : LOGO */}
          <div style={{ width: '30%' }}>
            <img src="/img/logo01.png" width={190} alt="Logo" />
          </div>

          {/* CENTRE : CLINIC NAME, sat between the logo and the doctor block */}
          <div style={{ width: '34%', textAlign: 'center', padding: '0 8px' }}>
            <p
              style={{
                margin: 0,
                fontSize: 18,
                fontWeight: 'bold',
                textTransform: 'uppercase',
                lineHeight: 1.25,
              }}
            >
              {form.clinicName}
            </p>
          </div>

          {/* RIGHT : DOCTOR DETAILS */}
          <div style={{ width: '34%', textAlign: 'right', fontSize: 13 }}>
            <p style={{ margin: '0 0 2px', fontSize: 15, fontWeight: 'bold' }}>{form.doctorName}</p>
            <p style={{ margin: '0 0 2px' }}>{form.qualification}</p>
            <p style={{ margin: '0 0 2px' }}>
              Mob: {form.mobile}
              {form.ext ? ` | Ext. ${form.ext}` : ''}
            </p>
            <p style={{ margin: 0 }}>{form.timings}</p>
          </div>
        </div>

        <h3
          style={{
            color: 'red',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            textAlign: 'center',
            margin: '22px 0 0',
          }}
        >
          {form.title}
        </h3>

        {form.certificateNo && (
          <p style={{ margin: '8px 0 0', fontSize: 12, textAlign: 'center' }}>
            Certificate No: {form.certificateNo}
          </p>
        )}
      </div>

      {/* ================= CONTENT ================= */}
      <div
        style={{
          flex: 1,
          padding: '40px 40px',
          fontSize: 15,
          lineHeight: 1.8,
          textAlign: 'justify',
          boxSizing: 'border-box',
          whiteSpace: 'pre-line',
          position: 'relative',
        }}
      >
        {form.bodyText}
      </div>

      {/* ================= SIGNATURE ================= */}
      <div style={{ padding: '0 60px 20px', boxSizing: 'border-box', position: 'relative' }}>
        <p style={{ margin: '0 0 6px' }}>Place: {form.place || '____________________'}</p>
        <p style={{ margin: 0 }}>Date: {formatDate(form.footerDate)}</p>

        <div style={{ textAlign: 'right', marginTop: 40 }}>
          <strong>{form.doctorName}</strong>
          <br />
          {form.qualification}
        </div>
      </div>

      {/* ================= FOOTER : ADDRESS ================= */}
      <div
        style={{
          borderTop: '1px solid #000',
          padding: '14px 40px',
          textAlign: 'center',
          fontSize: 13,
          boxSizing: 'border-box',
          position: 'relative',
        }}
      >
        {form.address}
      </div>
    </div>
  );
});

export default CertificateDocument;
